import script from "./time-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./time-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./time-widget-ly.vue?vue&type=style&index=0&id=932a74ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-932a74ac"]])

export default __exports__